"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceLinks = void 0;
// Function for replacing links in text in pipeable way
const replaceLinks = textLinks => inputText => {
  if (!textLinks || textLinks.length === 0) {
    return inputText;
  }
  return inputText.replaceAll(/{(\d+)}/g, (_, index) => {
    const link = textLinks[Number.parseInt(index, 10)];
    if (!link) {
      return '';
    }
    const url = link.relativeUrl ?? '#';
    const title = link.title ?? 'Link';
    return `<a data-index="${index}" href="${url}">${title}</a>`;
  });
};
exports.replaceLinks = replaceLinks;
